<template>
  <button class="btn add-valve"
          @click="onClick">
    <span>{{ pName }}</span>
    <span v-if="icon">&#43;</span>
  </button>
</template>

<script>
export default {
  name: 'CoddinButton',
  props: {
    pName: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    onClick() {
      this.active = true;
      this.$emit('codd_input');
    },
  },
}
</script>

<style lang="scss">
.btn.add-valve {
  border-radius: 50px;
  color: white;
  font-size: 12px;
  background-color: #3DB0C7;
  height: 32px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 16px;
  width: 100%;
  transition: all ease 0.3s;
  margin-bottom: 8px;
  margin-right: 10px;

  &:hover {
    background-color: darken(#3DB0C7, 10%);
    color: white;

    span + span {
      transform: scale(1.9);
    }
  }

  span {
    font-size: 12px;
    font-family: neue-haas-grotesk-display, sans-serif;
    letter-spacing: 0.5px;
    transition: all ease 0.3s;

    + span {
      transform: scale(1.5);
    }
  }
}

</style>
